"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameDayOrBefore = exports.isSameDayOrAfter = exports.isSameDayOrBetween = void 0;
const moment_1 = __importDefault(require("moment"));
/**
 * Checks whether a given date falls on the same day or within the range of a given start and end date.
 *
 * @param {MomentInput} date the date to compare
 * @param {MomentInput} start the start date of the range, inclusive
 * @param {MomentInput} end the end date of the range, inclusive
 *
 * @returns {boolean} true or false
 */
const isSameDayOrBetween = (date, start, end) => (0, moment_1.default)(date).isBetween(start, end, 'day', '[]');
exports.isSameDayOrBetween = isSameDayOrBetween;
/**
 * Checks whether a given date occurs on the same day or after a given target date.
 *
 * @param {MomentInput} date the date to compare against the target
 * @param {MomentInput} target the target date
 *
 * @returns {boolean} true or false
 */
const isSameDayOrAfter = (date, target) => (0, moment_1.default)(date).isSameOrAfter(target, 'day');
exports.isSameDayOrAfter = isSameDayOrAfter;
/**
 * Checks whether a given date occurs on the same day or before a given target date.
 *
 * @param {MomentInput} date the date to compare against the target
 * @param {MomentInput} target the target date
 *
 * @returns {boolean} true or false
 */
const isSameDayOrBefore = (date, target) => (0, moment_1.default)(date).isSameOrBefore(target, 'day');
exports.isSameDayOrBefore = isSameDayOrBefore;
//# sourceMappingURL=dateUtils.js.map